/**
 * Service to manage commands metadata
 */
export class CommandsMetadataService {
    constructor() {
        this.listeners = new Set();
    }
    setCommandsMetadata(commandsMetadata) {
        this.commandsMetadata = commandsMetadata;
        this.notifyListeners();
    }
    getCommandsMetadata() {
        return this.commandsMetadata ? [...this.commandsMetadata] : undefined;
    }
    onCommandsMetadataChanged(listener) {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    }
    notifyListeners() {
        const commandsMetadata = this.getCommandsMetadata();
        if (commandsMetadata) {
            this.listeners.forEach((listener) => {
                try {
                    listener(commandsMetadata);
                }
                catch (error) {
                    console.error('Error in CommandsMetadataService listener:', error);
                }
            });
        }
    }
}
//# sourceMappingURL=commands-metadata-service.js.map